import React, { Component } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { MoreVertical } from 'react-feather';
import './OptionsButton.css';

export default class OptionsButton extends Component
{
    render() {
        return (
            <div className="options-button">
                <UncontrolledDropdown inNavbar>
                    <DropdownToggle>
                        <MoreVertical size={18} />
                    </DropdownToggle>
                    <DropdownMenu right>
                        {this.props.children}
                    </DropdownMenu>
                </UncontrolledDropdown>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/OptionsButton.js